export const isHaveChildren = (children: unknown): children is [] => {
  return Array.isArray(children) && children.length > 0;
};
